import React from "react";
import { useLocation } from "@reach/router";
import { useSiteMetadata } from "../../../hooks/use-site-meta-data";

export const SEO = ({
  title,
  description,
  children,
  featuredImage,
  content,
}: any) => {
  const location = useLocation();
  const pathname = location.pathname + location.search;

  const { title: defaultTitle, siteUrl, twitterUsername } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description,
    url: `${siteUrl}${pathname || ``}`,
    image: `src/images/favicon-32x32.png`,
    twitterUsername,
    featuredImage:
      featuredImage ||
      `https://shop.medsupplysolutions.com/wp-content/uploads/2023/10/mss-ogimage.png`,
    content: content || "website",
  };

  const hreflangs = [{ href: `${siteUrl}${pathname || ``}`, hrefLang: "en" }];

  return (
    <>
      <title>{seo.title}</title>
      <meta property="og:locale" content="en_US" />
      <meta name="description" content={seo.description} />
      <meta name="image" content="src/images/favicon-32x32.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:creator" content={seo.twitterUsername} />
      <meta name="twitter:description" content={seo.description} />

      <meta property="og:description" content={seo.description} />
      <meta name="og:image" content={seo.featuredImage} />
      <meta name="og:title" content={seo.title} />
      <meta name="og:url" content={seo.url} />
      <meta name="og:type" content={seo.content} />

      {hreflangs.map((link) => (
        <link
          key={link.hrefLang}
          rel="alternate"
          href={link.href}
          hrefLang={link.hrefLang}
        />
      ))}

      {children}
    </>
  );
};
